// BackgroundSVGs.jsx
import React from "react";

export default function BackgroundSVGs() {
    return (
        <>
            <svg width="400" height="200" className="svg1" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <title>Layer 1</title>
                    <path id="svg_1" d="m547.39999,195.80001" opacity="1" stroke="#000" fill="#fff" />
                    <line id="svg_9" x1="317.01845" y1="70.97779" x2="156.59154" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_10" x1="134.89179" y1="98.63721" x2="156.59379" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_12" x1="134.89179" y1="98.55067" x2="118.72166" y2="98.55067" stroke="#ffffff" fill="none" />
                </g>
            </svg>

            <svg width="400" height="200" className="svg2" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(400,0) scale(-1,1)">
                    <title>Layer 1</title>
                    <path id="svg_1" d="m547.39999,195.80001" opacity="1" stroke="#000" fill="#fff" />
                    <line id="svg_9" x1="317.01845" y1="70.97779" x2="156.59154" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_10" x1="134.89179" y1="98.63721" x2="156.59379" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_12" x1="134.89179" y1="98.55067" x2="118.72166" y2="98.55067" stroke="#ffffff" fill="none" />
                </g>
            </svg>

            <svg width="400" height="200" className="svg3" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <title>Layer 1</title>
                    <path id="svg_1" d="m547.39999,195.80001" opacity="1" stroke="#000" fill="#fff" />
                    <line id="svg_9" x1="317.01845" y1="70.97779" x2="156.59154" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_10" x1="134.89179" y1="98.63721" x2="156.59379" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_12" x1="134.89179" y1="98.55067" x2="118.72166" y2="98.55067" stroke="#ffffff" fill="none" />
                </g>
            </svg>

            <svg width="400" height="200" className="svg4" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(400,0) scale(-1,1)">
                    <title>Layer 1</title>
                    <path id="svg_1" d="m547.39999,195.80001" opacity="1" stroke="#000" fill="#fff" />
                    <line id="svg_9" x1="317.01845" y1="70.97779" x2="156.59154" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_10" x1="134.89179" y1="98.63721" x2="156.59379" y2="70.97779" stroke="#ffffff" fill="none" />
                    <line id="svg_12" x1="134.89179" y1="98.55067" x2="118.72166" y2="98.55067" stroke="#ffffff" fill="none" />
                </g>
            </svg>

            <svg width="22" height="934" xmlns="http://www.w3.org/2000/svg" className="svg5">
                <g>
                    <title>Layer 1</title>
                    <path id="svg_1" d="m547.39999,195.80001" opacity="1" stroke="#000" fill="#fff" />
                    <g id="svg_34">
                        <rect id="svg_25" height="124.07155" width="22.22177" y="0.39464" x="0.19053" stroke="#ffffff" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_26" height="86.86225" width="22.22177" y="132.95278" x="-0.58466" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_27" height="56.62969" width="22.22177" y="228.30161" x="-0.58466" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_28" height="39.29636" width="22.22177" y="292.96829" x="0.082" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_29" height="39.29636" width="22.22177" y="339.63495" x="-0.58466" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_30" height="28.61971" width="22.22177" y="386.56202" x="-0.29295" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_32" height="20.28672" width="22.22177" y="421.71684" x="-0.55336" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_33" height="15.33901" width="22.22177" y="448.53866" x="-0.29295" fill="#d1d1d1ff" />
                    </g>
                    <g transform="rotate(-180 12.2471 702.803)" id="svg_43">
                        <rect id="svg_35" height="124.07155" width="22.22177" y="471.0613" x="1.52386" stroke="#ffffff" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_36" height="86.86225" width="22.22177" y="603.61944" x="0.74867" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_37" height="56.62969" width="22.22177" y="698.96827" x="0.74867" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_38" height="39.29636" width="22.22177" y="763.63494" x="1.41534" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_39" height="39.29636" width="22.22177" y="810.30161" x="0.74867" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_40" height="28.61971" width="22.22177" y="857.22867" x="1.04038" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_41" height="20.28672" width="22.22177" y="892.38349" x="0.77997" fill="#d1d1d1ff" />
                        <rect stroke="#ffffff" id="svg_42" height="15.33901" width="22.22177" y="919.20531" x="1.04038" fill="#d1d1d1ff" />
                    </g>
                </g>
            </svg>

            <svg width="22" height="1000" className="svg6" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <title>Layer 1</title>
                    <line x1="6.25941" y1="31.3257" x2="6.25941" y2="962.69716" stroke="#ffffff" fill="none" />
                    <line x1="6.33333" y1="31.99999" x2="17.66666" y2="15.99999" stroke="#ffffff" fill="none" />
                </g>
            </svg>

            <svg width="150" height="99.99999999999999" xmlns="http://www.w3.org/2000/svg" className="svg7">

                <g>
                    <title>Layer 1</title>
                    <path id="svg_1" d="m547.39999,195.80001" opacity="1" stroke="#000" fill="#fff" />
                    <g id="svg_80">
                        <g id="svg_76">
                            <line id="svg_74" y2="3.35076" x2="2.85993" y1="3.35076" x1="16.80725" stroke="#ffffff" fill="none" />
                            <line transform="rotate(-90 3.33372 10.4473)" id="svg_75" y2="10.44728" x2="-3.63995" y1="10.44728" x1="10.30738" stroke="#ffffff" fill="none" />
                        </g>
                        <g transform="rotate(90 138.164 9.55251)" id="svg_79">
                            <line id="svg_77" y2="2.51744" x2="131.19074" y1="2.51744" x1="145.13806" stroke="#ffffff" fill="none" />
                            <line transform="rotate(-90 131.664 9.61401)" id="svg_78" y2="9.61396" x2="124.69087" y1="9.61396" x1="138.63819" stroke="#ffffff" fill="none" />
                        </g>
                    </g>
                    <g transform="rotate(-180 75.3628 89.6652)" id="svg_87">
                        <g id="svg_83">
                            <line id="svg_81" y2="83.01586" x2="4.19323" y1="83.01586" x1="18.14056" stroke="#ffffff" fill="none" />
                            <line transform="rotate(-90 4.66702 90.1124)" id="svg_82" y2="90.11238" x2="-2.30664" y1="90.11238" x1="11.64068" stroke="#ffffff" fill="none" />
                        </g>
                        <g transform="rotate(90 139.497 89.2176)" id="svg_86">
                            <line id="svg_84" y2="82.18254" x2="132.52405" y1="82.18254" x1="146.47137" stroke="#ffffff" fill="none" />
                            <line transform="rotate(-90 132.997 89.2791)" id="svg_85" y2="89.27906" x2="126.02417" y1="89.27906" x1="139.9715" stroke="#ffffff" fill="none" />
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg className="svg9" width="177" height="620" viewBox="0 0 177 640" fill="none" xmlns="http://www.w3.org/2000/svg">
  
  <path d="M168.075 639L168.075 539" stroke="#d1d1d1ff" stroke-width="0.685824"/>
  
  <rect x="167.916" y="334.64" width="7.83809" height="100.058" fill="#d1d1d1ff"/>
  <rect x="167.916" y="89" width="7.83809" height="100.058" fill="#d1d1d1ff"/>
  <rect x="160.075" y="189.059" width="7.83809" height="145.581" fill="#d1d1d1ff"/>
  <path d="M168.075 539V9.22187L176.297 1" stroke="#d1d1d1ff" strokeWidth="0.685824"/>
            </svg>

      </>
    );
}
